import { render, staticRenderFns } from "./units-filter.vue?vue&type=template&id=d40c2050&scoped=true&"
import script from "./units-filter.vue?vue&type=script&lang=js&"
export * from "./units-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40c2050",
  null
  
)

export default component.exports